import CadastroScreen from './CadastroScreen'

export default CadastroScreen
